





















































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Button from '@/app/ui/components/Button/index.vue'
import CRRNFD from '../components/PickupItem/CRRNFD/index.vue'
import CRROTW from '../components/PickupItem/CRROTW/index.vue'
import DOX from '../components/PickupItem/DOX/index.vue'
import CRRPIC from '../components/PickupItem/CRRPIC/index.vue'
import CRRDON from '../components/PickupItem/CRRDON/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import IconSync from '@/app/ui/assets/icon_sync.vue'
import controller from '@/app/ui/controllers/PickupController'
import {
  LocalStorage,
  PICKUP_PAGINATION,
  Utils,
} from '@/app/infrastructures/misc'
import dayjs from 'dayjs'
import { Pickup } from '@/domain/entities/Pickup'
import Loading from '@/app/ui/components/Loading/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import ModalSuccess from '../components/Modals/ModalSuccess.vue'
import DropdownMultiSelect from '../components/DropdownMultiSelect/index.vue'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import ModalExportLog from '../components/Modals/ModalExportLog.vue'
import ModalExportCRRNFD from '../components/Modals/ModalExportCRRNFD.vue'
import WidgetDownload from '@/app/ui/components/WidgetDownload/index.vue'
import { ExportPickupRequest } from '@/data/payload/api/PickupRequest'
import { FlagsAccount } from '@/feature-flags'
import FleetAppFilterButton from '@/app/ui/views/Pickup/components/FleetAppFilterButton/index.vue';

@Component({
  components: {
    Button,
    CRRNFD,
    CRROTW,
    DOX,
    CRRPIC,
    CRRDON,
    LoadingOverlay,
    IconSync,
    Loading,
    TextInput,
    DropdownSelect,
    ModalSuccess,
    DropdownMultiSelect,
    PaginationNav,
    ModalExportLog,
    ModalExportCRRNFD,
    WidgetDownload,
    FleetAppFilterButton
  },
})
export default class PickupDashboardPage extends Vue {
  controller = controller
  firstFetchComplete = false

  modalSuccessCRRSRCVisible = false
  showModalExportLog = false
  // showModalExportCRRNFD = false

  parameters = {
    page: 1,
    search: '',
    perPage: 10,
    shipmentType: [],
  }

  shipmentTypeOptions = [
    {
      label: 'Delivery Order (DO)',
      value: 'delivery_order',
    },
    {
      label: 'Marketplace (MP)',
      value: 'marketplace',
    },
    {
      label: 'Customer Apps (CA)',
      value: 'customer',
    },
    {
      label: 'Corporate',
      value: 'corporate',
    },
    {
      label: 'Aggregator (C1)',
      value: 'aggregator',
    },
  ]

  isFleetApp = ''

  created(): void {
    this.fetchPickups(true)
  }

  mounted(): void {
    this.setObserver()
  }

  private setObserver(): void {
    if (this.isIgnoreInfiniteScroll) return
    const el = this.$el.getElementsByClassName('end-of-page')[0]

    if (el) {
      const observer = new IntersectionObserver(
        (entries: IntersectionObserverEntry[]): void => {
          if (
            entries[0].isIntersecting &&
            !this.isLoading &&
            !this.isLastPage &&
            this.pickupData.length !== 0
          ) {
            this.parameters.page++
            this.fetchPickups(false)
          }
        },
        {
          root: document.getElementById('#app'),
          threshold: 1.0,
        }
      )

      observer.observe(el)
    }
  }

  get isMyWhitelist() {
    return FlagsAccount.pickup_dashboard_liberta_my_whitelist.isEnabled();
  }

  @Watch('isMyWhitelist')
  isMyWhitelistChanged() {
    this.fetchPickups(true);
  }

  private fetchPickups(reset: boolean): void {
    if (reset) this.parameters.page = 1

    const payload = {
      statusId: this.statusId,
      page: this.parameters.page,
      perPage: this.isIgnoreInfiniteScroll
        ? this.parameters.perPage
        : PICKUP_PAGINATION,
      dateFrom: dayjs()
        .subtract(1, 'week')
        .format('YYYY-MM-DD'),
      sortDirection: 'ASC',
      statusIds: this.$route.meta.additional.statusIds,
      refetch: false,
      sync: false,
      clear: false,
      reset: reset,
      keyword: this.parameters.search || undefined,
      shipmentType: <string | undefined>(
        this.parameters.shipmentType
          .map(
            type =>
              this.shipmentTypeOptions.find(option => option.label === type)
                ?.value
          )
          .join(',')
      ),
      originCountry: this.isMyWhitelist ? 'Malaysia' : '',
      executionPlatform: this.isFleetApp
    }

    if (!this.parameters.search) {
      delete payload.keyword
    }

    if (!this.isShowShipmentTypeFilter && !this.isCRRDON) {
      delete payload.shipmentType
    }

    controller.getPickupList(payload)
  }

  private onFilter(): void {
    this.fetchPickups(true)
  }

  get isLastPage(): boolean {
    return this.totalPages === controller.paginationData.page
  }

  get totalPages(): number {
    return Math.ceil(
      Number(controller.paginationData.totalItem) /
        Number(controller.paginationData.perPage)
    )
  }

  get tableHeader(): string[] {
    const statusHeader: Record<string, string[]> = {
      CRRNFD: [
        'No.',
        'ORDER ID',
        'CUSTOMER',
        'PHONE',
        'STATUS',
        'DATE TIME',
        'DURATION',
        '',
      ],
      DOX: [
        'No.',
        'ORDER ID',
        'STT Actual',
        'CUSTOMER',
        'PHONE',
        'STATUS',
        'DATE TIME',
        'DURATION',
        '',
      ],
      CRROTW: [
        'No.',
        'ORDER ID',
        'CUSTOMER',
        'PHONE',
        'STATUS',
        'ADDRESS',
        'COURIER',
        'UPDATE',
        'DURATION',
        '',
      ],
      CRRPIC: [
        'No.',
        'ORDER ID',
        'CUSTOMER',
        'PHONE',
        'STATUS',
        'ADDRESS',
        'COURIER',
        'UPDATE',
        'DURATION',
        '',
      ],
      CRRDON: [
        'No.',
        'ORDER ID',
        'CUSTOMER',
        'STATUS',
        'COURIER',
        'CREATED',
        'UPDATED',
      ],
    }

    return statusHeader[this.$route.meta.additional.statusId as string]
  }

  get pickupData(): Pickup[] {
    return controller.pickupData
  }

  get statusId(): string {
    return this.$route.meta.additional.statusId as string
  }

  get pageTitle(): string {
    return this.$route.meta.additional.pageTitle
  }

  get downloadable(): boolean {
    return this.$route.meta.additional.download as boolean
  }

  get manualAssignee(): boolean {
    return this.$route.meta.additional.manualAssignee as boolean
  }

  get isLoading(): boolean {
    return controller.isLoading
  }

  get isExportLoading(): boolean {
    return controller.isExportLoading
  }

  get isCRRNFDExportLoading(): boolean {
    return controller.isExportCRRNFDLoading
  }

  get latestSync(): string {
    if (!controller.latestSync) {
      return ''
    }

    return dayjs(controller.latestSync).format('DD-MM-YY HH:mm')
  }

  get isCRROTW(): boolean {
    return this.statusId === 'CRROTW'
  }

  get isCRRPIC(): boolean {
    return this.statusId === 'CRRPIC'
  }

  get isCRRDON(): boolean {
    return this.statusId === 'CRRDON'
  }

  get isCRRNFD(): boolean {
    return this.statusId === 'CRRNFD'
  }

  get isDOX(): boolean {
    return this.statusId === "DOX"
  }

  get isShowShipmentTypeFilter(): boolean {
    return this.isCRROTW || this.isCRRPIC
  }

  get isexportPickupListLoading(): boolean {
    return controller.isexportPickupListLoading
  }

  get isExportCRRPICLoading(): boolean {
    return controller.isExportCRRPICLoading;
  }

  get isExportCRRDONLoading(): boolean {
    return controller.isExportCRRDONLoading;
  }

  get isExportCRROTWLoading(): boolean {
    return controller.isExportCRROTWLoading;
  }

  get isExportDOXLoading(): boolean {
    return controller.isExportDOXLoading;
  }

  get isIgnoreInfiniteScroll(): boolean {
    return this.isCRRNFD
  }

  onFleetApp(value: string) {
    this.isFleetApp = value

    this.fetchPickups(true)
  }

  private handleExport() {
    const email = LocalStorage.getLocalStorage(
      LocalStorage.LOGIN_IDENTITY,
      true
    )

    controller.exportPickup({
      statusId: this.statusId,
      email,
    })
  }

  private handleExportCRRNFD(): void {
    const params = {
      file_name: `CRRNFD-${Utils.formatDateWithIDLocale(
        dayjs(),
        'YYYYMMDDHHmss'
      )}`,
      date_from: Utils.formatDate(dayjs().subtract(1, 'week'), 'YYYY-MM-DD'),
      sort_direction: 'ASC',
    }

    controller.exportCRRNFD(params)
  }

  private handleExportPickupList(): void {
    const params = {
      file_name: `${this.statusId}-${Utils.formatDateWithIDLocale(
        dayjs(),
        'YYYYMMDDHHmss'
      )}`,
      date_from: Utils.formatDate(dayjs().subtract(1, 'week'), 'YYYY-MM-DD'),
      keyword: this.parameters.search || undefined,
      shipmentType: <string | undefined>(
        this.parameters.shipmentType
          .map(
            type =>
              this.shipmentTypeOptions.find(option => option.label === type)
                ?.value
          )
          .join(',')
      ),
      statusId: this.statusId,
    }

    if (!this.parameters.search) {
      delete params.keyword
    }

    controller.exportPickupList(params)
  }

  private syncData() {
    this.fetchPickups(true)
  }

  private onSearch: () => void = Utils.debounce(() => {
    this.fetchPickups(true)
  }, 500)

  @Watch('controller.isForceCRRSRCSuccess')
  onIsForceCRRSRCSuccessChange(data: boolean): void {
    if (data) {
      this.modalSuccessCRRSRCVisible = true
      this.fetchPickups(true)
      this.controller.setIsForceCRRSRCSuccess(false)
    }
  }

  private async onExport() {
    const fileName = `${this.statusId}-${Utils.formatDateWithIDLocale(
      dayjs(),
      'YYYYMMDDHHmss'
    )}`
    const dateFrom = dayjs()
            .subtract(1, 'week')
            .format('YYYY-MM-DD')

    const email = LocalStorage.getLocalStorage(
      LocalStorage.LOGIN_IDENTITY,
      true
    )

    if (this.isCRRPIC) {
      // this.controller.getExportPickup('/pickup-otw/export')
      this.controller.setExportCRRPICLoading(true);
      this.controller.getExportPickup(new ExportPickupRequest({
        statusId: "CRRPIC",
        route: "/pickup-otw/export",
        payload: Utils.toInstance(new Map, JSON.stringify({
          fileName,
          dateFrom,
          originCountry: this.isMyWhitelist ? 'Malaysia' : '',
          executionPlatform: this.isFleetApp || undefined,
          keyword: this.parameters.search || undefined
        }), "snake_case")
      })).finally(() => {
        this.controller.setExportCRRPICLoading(false);
      })
    } else if (this.isCRRDON) {
      // this.controller.getExportPickup('/pickup/export')
      this.controller.setExportCRRDONLoading(true);
      this.controller.getExportPickup(new ExportPickupRequest({
        statusId: "CRRDON",
        route: "/pickup/export",
        payload: Utils.toInstance(new Map(), JSON.stringify({
          fileName,
          statusId: "CRRDON",
          dateFrom,
          originCountry: this.isMyWhitelist ? 'Malaysia' : ''
        }), "snake_case")
      })).finally(() => {
        this.controller.setExportCRRDONLoading(false);
      })
    } else if (this.isCRRNFD) {
      // this.controller.getExportPickup('/pickup-crrnfd/export')
      this.controller.getExportPickup(new ExportPickupRequest({
        statusId: "CRRNFD",
        route: "/pickup-crrnfd/export",
        payload: Utils.toInstance(new Map(), JSON.stringify({
          fileName,
          originCountry: this.isMyWhitelist ? 'Malaysia' : ''
        }), "snake_case")
      }))
    } else {
      // this.controller.getExportPickup('/delivery-order/export')
      this.controller.setExportDOXLoading(true);
      this.controller.getExportPickup(new ExportPickupRequest({
        statusId: "DOX",
        method: "POST",
        route: "/delivery-order/export",
        payload: Utils.toInstance(new Map(), JSON.stringify({
          fileName,
          dateFrom,
          email,
          originCountry: this.isMyWhitelist ? 'Malaysia' : ''
        }), "snake_case")
      })).finally(() => {
        this.controller.setExportDOXLoading(false);
      })
    }
  }
}
